<template>
  <v-col cols="12">
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card>
      <v-card-title>Idées séjours</v-card-title>

      <v-card-text>
        <div class="global-actions">
          <router-link :to="{ name: 'thematicCreate' }">
            <v-btn
              small
              color="primary"
              class="mt-5"
            >
              Ajouter une idée séjour
            </v-btn>
          </router-link>
        </div>
      </v-card-text>

      <v-row class="mb-5">
        <v-col
          class="tags-search ml-5"
          cols="2"
          sm="2"
        >
          <vue-tags-input
            v-model="tag"
            :tags="tags"
            placeholder="Recherche"
            @tags-changed="newTags => {
              tags = newTags
              search()
            }"
          />
        </v-col>

        <v-col
          cols="12"
          sm="6"
        >
          <v-btn
            class="mt-1"
            small
            color="info"
            @click="search()"
          >
            <v-icon
              small
              class="mr-1"
            >
              {{ icons.mdiDatabaseSearchOutline }}
            </v-icon>
            <i class="fas fa-search"></i>
            Rechercher
          </v-btn>
          <v-btn
            small
            color="info"
            class="ml-2 mt-1"
            @click="reset()"
          >
            <v-icon
              small
              class="mr-1"
            >
              {{ icons.mdiBackupRestore }}
            </v-icon>
            Réinitialisation
          </v-btn>
        </v-col>
      </v-row>

      <div class="clear"></div>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-uppercase">
                Nom
              </th>
              <th class="text-center text-uppercase">
                Position
              </th>
              <th class="text-center text-uppercase">
                Home
              </th>
              <th class="text-center text-uppercase">
                Etat
              </th>
              <th class="text-center text-uppercase">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(thematic, thematicIndex) in thematics"
              :key="'e' + thematicIndex"
            >
              <td class="font-weight-bold">
                {{ thematic.name }}
              </td>
              <td class="text-center">
                {{ thematic.position }}
              </td>
              <td class="text-center">
                <template v-if="resolveOnHomeLocales(thematic).length">
                  <v-chip
                    v-for="locale in resolveOnHomeLocales(thematic)"
                    :key="locale"
                    color="info"
                    text-color="white"
                    small
                    class="mr-1"
                  >
                    {{ locale.toUpperCase() }}
                  </v-chip>
                </template>
                <v-chip
                  v-else
                  color="error"
                  text-color="white"
                  small
                >
                  Aucune
                </v-chip>
              </td>
              <td class="text-center">
                <v-chip
                  v-if="thematic.enabled"
                  color="success"
                  text-color="white"
                  small
                >
                  Activé
                </v-chip>
                <v-chip
                  v-if="!thematic.enabled"
                  color="error"
                  text-color="white"
                  small
                >
                  Désactivé
                </v-chip>
              </td>
              <td class="text-center">
                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      :to="{ name: 'thematicDetails', params: { thematicId: thematic.id }}"
                    >
                      <v-icon dark>
                        {{ icons.mdiEye }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Consulter</span>
                </v-tooltip>

                <v-tooltip top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      class="ml-2"
                      color="error"
                      fab
                      dark
                      x-small
                      v-bind="attrs"
                      @click="openDeleteThematicDialog(thematic)"
                    >
                      <v-icon dark>
                        {{ icons.mdiTrashCan }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Supprimer</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
          <tbody v-if="!thematics.length">
            <tr>
              <td>
                <span v-if="loading === false">Aucun éléments.</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <DeleteThematicDialog
        :key="Date.now()"
        :delete-thematic-dialog-state="deleteThematicDialogState"
        :thematic="thematicToDelete"
        @closeDeleteThematicDialog="closeDeleteThematicDialog($event)"
      ></DeleteThematicDialog>
    </v-card>
  </v-col>
</template>

<script>
import { mdiPlay, mdiPen, mdiEye, mdiTrashCan, mdiBackupRestore, mdiDatabaseSearchOutline } from '@mdi/js'
import Vue from 'vue'
import DeleteThematicDialog from '@/components/Dialog/ThematicDialog/DeleteThematicDialog'
import config from '../../config'
import Loader from '@/components/Common/Loader'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  components: {
    DeleteThematicDialog,
    Loader,
    VueTagsInput
  },
  data: () => ({
    nextPage: 1,
    tag: '',
    tags: [],
    thematics: [],
    thematicToDelete: null,
    deleteThematicDialogState: false,
    loading: false,
    icons: {
      mdiPlay,
      mdiPen,
      mdiEye,
      mdiTrashCan,
      mdiBackupRestore,
      mdiDatabaseSearchOutline
    }
  }),
  computed: {
    isHandlingThematicScroll () {
      return this.$store.getters.isHandlingThematicScroll
    }
  },
  created () {
    this.getThematics()

    window.removeEventListener('scroll', this.handleScroll)

    setTimeout(() => {
      window.addEventListener('scroll', this.handleScroll)
    }, 1000)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll () {
      const wrapperOffsetHeight = document.querySelector('.v-application--wrap').offsetHeight
      const bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) === wrapperOffsetHeight

      if (bottomOfWindow && !this.isHandlingThematicScroll) {
        this.getThematics()
      }
    },
    getThematics () {
      this.loading = true

      const params = {
        page: this.nextPage
      }

      const terms = []

      for (let i = 0; i < this.tags.length; i++) {
        terms.push(this.tags[i].text)
      }

      if (terms.length) {
        params.terms = terms.join(',')
      }

      this.$store.commit('setHandlingThematicScroll', true)

      Vue.prototype.$http
        .get(config.apiUrl + '/api/thematics', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const thematics = response.data

            if (thematics && thematics.length) {
              this.thematics.push(...thematics)

              this.nextPage = this.nextPage + 1
            }
          }

          this.loading = false
          this.$store.commit('setHandlingThematicScroll', false)
        })
        .catch(e => {
          const response = e.response

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
          this.$store.commit('setHandlingThematicScroll', false)
        })
    },
    search () {
      const params = {
        page: 1
      }

      const terms = []

      for (let i = 0; i < this.tags.length; i++) {
        terms.push(this.tags[i].text)
      }

      if (terms.length) {
        params.terms = terms.join(',')
      }

      Vue.prototype.$http
        .get(config.apiUrl + '/api/thematics', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            this.thematics = response.data

            this.nextPage = 2
          }
        })
        .catch(() => {
        })
    },
    reset () {
      this.tag = ''
      this.tags = []

      this.search()
    },
    openDeleteThematicDialog (thematic) {
      this.deleteThematicDialogState = true
      this.thematicToDelete = thematic
    },
    closeDeleteThematicDialog (deleteState) {
      if (deleteState === true) {
        this.thematics = this.thematics.filter(element => element.id !== this.thematicToDelete.id)
      }

      this.deleteThematicDialogState = false
    },
    resolveOnHomeLocales (thematic) {
      if (!thematic) {
        return []
      }

      const locales = thematic.onHomeLocales

      if (!locales) {
        return []
      }

      if (Array.isArray(locales)) {
        return locales.map(locale => String(locale).trim()).filter(Boolean)
      }

      if (typeof locales === 'string') {
        return locales.split(',').map(locale => locale.trim()).filter(Boolean)
      }

      return []
    }
  }
}
</script>
